import { apiClient } from './client';

export const authApi = {
  login(login, password) {
    return apiClient.post('/auth/login', { login, password });
  },

  logout() {
    return apiClient.post('/auth/logout');
  },

  me() {
    return apiClient.get('/auth/me');
  },
};
